import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import moment from 'moment';

import { ITepEntryPass } from 'types/tep';
import { close, edit2, save } from 'assets/icons';
import { Tooltip } from 'components/atoms/tooltip';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { issueModalActionsSelector } from 'core/redux/selectors/tep';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

interface IActionsProps {
  entryPass: ITepEntryPass;
}

export const Actions: FC<IActionsProps> = ({ entryPass }) => {
  const dispatch = useDispatch();

  const { id, leases } = useSelector(issueModalActionsSelector);

  const { handleSubmit } = useFormContext<{ returnedOn: Date }>();

  const isSelected = entryPass?.id === id;

  const setSelectedLease = (id: number | null) => dispatch(leasesActions.edit({ id }));

  const onEdit = () => setSelectedLease(entryPass.id);

  const onCancel = () => setSelectedLease(null);

  const onSave = () => {
    if (id) {
      handleSubmit(({ returnedOn }) => {
        const updatedSelected = leases.map((entryPass) =>
          entryPass.id === id
            ? { ...entryPass, lease: { ...entryPass.lease, returnedOn: moment(returnedOn).format('YYYY-MM-DD') } }
            : entryPass,
        );

        dispatch(leasesActions.select({ leases: updatedSelected }));
        onCancel();
      })();
    }
  };

  return (
    <div className={styles.actions}>
      {isSelected ? (
        <>
          <Tooltip text="save">
            <SvgWrapper width={24} height={24} details={save} onClick={onSave} />
          </Tooltip>
          <Tooltip text="close without saving">
            <SvgWrapper width={24} height={24} details={close} onClick={onCancel} />
          </Tooltip>
        </>
      ) : (
        <Tooltip text="edit">
          <SvgWrapper width={24} height={24} details={edit2} onClick={onEdit} />
        </Tooltip>
      )}
    </div>
  );
};
